import React, { useContext } from 'react'
import { View } from 'oio-react'
import PropTypes from 'prop-types'
import ProtoThemeContext from 'src/libraries/contexts/ProtoTheme'

const ContainerBlock = ({ children }) => {
   const { protoTheme: theme } = useContext(ProtoThemeContext)

   return (
      <View
         width="100%"
         maxWidth={theme.viewportContentMaxWidth}
         paddingHorizontal={`
            ${theme.tmpViewportPaddingA}[a]
            ${theme.tmpViewportPaddingB}[b]
            ${theme.tmpViewportPaddingC}[c]
            30px[d-f]
         `}>
         {children}
      </View>
   )
}

ContainerBlock.propTypes = {
   children: PropTypes.node.isRequired
}

export default ContainerBlock
